import { Component } from '@angular/core';
import { IonicModule, ModalController } from '@ionic/angular';
import { TranslateModule } from '@ngx-translate/core';
import { TitleModule } from '@smatchy/components/components/shared-ui/title/title.module';
import { PushNotificationAdapter } from '../../../../../adapters/push-notification.adapter';
import { IconModule } from '../../atoms/icon/icon.module';

@Component({
  selector: 'smatchy-notification-modale',
  templateUrl: './notification-modale.component.html',
  styleUrls: ['./notification-modale.component.scss'],
  imports: [IonicModule, TranslateModule, TitleModule, IconModule],
})
export class NotificationModalPage {
  constructor(
    private modalController: ModalController,
    private readonly _pushNotificationAdapter: PushNotificationAdapter,
  ) {}

  dismiss() {
    localStorage.setItem('notificationsAsked', 'true');
    this.modalController.dismiss();
  }

  async enableNotifications() {
    await this._pushNotificationAdapter.requestPermission();
    localStorage.setItem('notificationsAsked', 'true');
    await this.modalController.dismiss();
  }
}
